import Image from 'next/image'
import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {getPricingContent} from '@/content/pricing'
import {Trans, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

export const PricingMultiCountryBanner: FC<React.PropsWithChildren<unknown>> = () => {
  const {t} = useTranslation('page')
  const {title, description, imageSrc, imageAlt} = getPricingContent().discount

  return (
    <>
      <div className="wrapper">
        <Text variant={TextVariant.h6}>{t(title)}</Text>
        <div className="content">
          <Text variant={TextVariant.text14}>
            <Trans i18nKey={description} ns="page" />
          </Text>
          <div className="image">
            <Image
              src={imageSrc}
              alt={imageAlt}
              style={{objectFit: 'contain'}}
              width={80}
              height={60}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          padding: ${theme.spacing[4]};
          background-color: ${theme.palette.background.butter};
          border-radius: 16px;
        }
        .content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: ${theme.spacing[3]};
        }
        .image {
          position: relative;
          width: 80px;
          height: 60px;
          flex: 0 0 80px;
          margin-left: ${theme.spacing[4]};
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .wrapper {
            text-align: center;
          }
          .content {
            display: block;
          }
          .image {
            margin: ${theme.spacing[3]} auto -${theme.spacing[4]};
          }
        }
      `}</style>
    </>
  )
}
